module.exports = __webpack_public_path__ + "static/media/minnows.80ec5db4.png";